import { App } from '@/app';
import * as Sentry from '@sentry/react';
import { Chart } from 'chart.js';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './sentry/sentry.config';
import { applyChartLegendEventGuard } from './ui/charts/legend-event-guard';

initSentry();
applyChartLegendEventGuard();

Chart.register({
  id: 'canvas-null-guard',
  beforeEvent(chart) {
    if (!chart.canvas) return false;
  },
  beforeRender(chart) {
    if (!chart.canvas) return false;
  },
});

const ErrorFallback = () => (
  <main role="alert" aria-live="assertive">
    <p>Something went wrong.</p>
    <button type="button" onClick={() => window.location.reload()}>
      Reload page
    </button>
  </main>
);

// eslint-disable-next-line
(window as any).renderApp = (id: string) => {
  const root = ReactDOM.createRoot(document.getElementById(id) as HTMLElement);

  root.render(
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      <App />
    </Sentry.ErrorBoundary>,
  );
};

if (document.getElementById('root')) {
  // eslint-disable-next-line
  (window as any).renderApp('root');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
